// extracted by mini-css-extract-plugin
module.exports = {"text_area":"textArea_text_area__11zA6"};